/* TODO: t() */
/* eslint-disable @typescript-eslint/no-floating-promises */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { Fragment, useState } from 'react';
import { View, StyleSheet, ScrollView } from 'react-native';

import { Button, Text, TextInputCounter, Link } from '../uiold';
import { themeColors } from '../uiold/Constants';

import { MarketPayments, CategoryName } from '../../types/shared/MarketSales';

type Props = {
  marketPayments: MarketPayments;
  onPaymentSave: (paymentID: string, paymentName: string) => Promise<void>;
};

type ItemProps = {
  payment: CategoryName;
  onPaymentSave: (paymentName: string) => Promise<void>;
};

function PaymentList(props: Props) {
  let { marketPayments, onPaymentSave } = props;

  let paymentIDs = Object.keys(marketPayments);

  return (
    <Fragment>
      <Text style={styles.paymentCount}>
        {paymentIDs.length} {paymentIDs.length === 1 ? 'payment' : 'payments'}
      </Text>
      <ScrollView>
        {paymentIDs.map((id) => {
          let payment = marketPayments[id];
          return (
            <PaymentListItem
              key={id}
              payment={payment as any}
              onPaymentSave={(name: string) => onPaymentSave(id, name)}
            />
          );
        })}
      </ScrollView>
    </Fragment>
  );
}

function PaymentListItem(props: ItemProps) {
  let { payment, onPaymentSave } = props;

  let [isEditing, setEditing] = useState(false);
  let [paymentName, setPaymentName] = useState(payment.name);

  let onSubmit = () => {
    if (!paymentName) {
      return;
    }
    onPaymentSave(paymentName);
    setEditing(false);
  };

  if (isEditing) {
    return (
      <View style={styles.paymentContainer}>
        <TextInputCounter
          autoFocus
          value={paymentName}
          maxLength={40}
          onChangeText={setPaymentName}
          onSubmitEditing={onSubmit}
          containerStyle={styles.paymentInputContainer}
        />
        <View style={styles.paymentActionContainer}>
          <Button onPress={() => setEditing(false)} title="Cancel" />
          <Button
            isPrimary
            title="Save Changes"
            isDisabled={!paymentName}
            onPress={onSubmit}
          />
        </View>
      </View>
    );
  }

  return (
    <View style={styles.paymentContainer}>
      <Text>{payment.name}</Text>
      <View style={styles.paymentActionContainer}>
        <Link onPress={() => setEditing(true)}>Edit</Link>
      </View>
    </View>
  );
}

let styles = StyleSheet.create({
  paymentCount: {
    marginBottom: 8,
  },
  paymentContainer: {
    flexDirection: 'row',
    padding: 16,
    borderBottomWidth: 1,
    borderBottomColor: themeColors.borderGrey,
  },
  paymentActionContainer: {
    flex: 1,
    flexDirection: 'row',
    justifyContent: 'flex-end',
    alignItems: 'center',
    minWidth: '30%',
  },
  paymentInputContainer: {
    minWidth: '60%',
  },
});

export default PaymentList;
